import React  from 'react'
import BundleGroupUI from "./bundleGroup.presenter";
import {useSelector} from "react-redux";
export default function BundleGroup({data}){
    const {domain} = useSelector(state => state.initial)
    let styleProps = {}

    switch (domain){
        case 'pc':{
            styleProps = {
                ...styleProps,
                wrapperLeftCol : '435px',
                wrapperLeftColPadding : '20px',
                wrapperRightCol : '434px',
                wrapperRightColPadding : '19px'
            }
            break
        }
        case 'shopping':{
            styleProps = {
                ...styleProps,
                wrapperLeftCol : '465px',
                wrapperLeftColPadding : '25px',
                wrapperRightCol : '464px',
                wrapperRightColPadding : '24px',
            }
            break
        }
        case 'minishop':{
            styleProps = {
                ...styleProps,
                wrapperLeftCol : '435px',
                wrapperLeftColPadding : '20px',
                wrapperRightCol : '434px',
                wrapperRightColPadding : '19px'
            }
            break
        }
        default :
            styleProps = {
                ...styleProps,
                wrapperLeftCol : '435px',
                wrapperRightCol : '434px'
            }
    }

    return (
        <div>
            <BundleGroupUI data={data} styleProps={styleProps}/>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/bundleGroup/bundleGroup.container.js